<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Returns</li>
    </ol>
  </nav>

  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col-8">
      <!--
                  <ul class="list-inline tab-list">
                      <li class="list-inline-item"><a (click)="populateTabData('all','ALL'); resetCheckedList(); tabChange()" [ngClass]="{'active': tabClicked === 'all'}">All</a></li>
                      <li class="list-inline-item"><a (click)="populateTabData('submitted','SUBMITTED');resetCheckedList(); tabChange()" (click)="cancelMultiReturnOrders(orders)" [ngClass]="{'active': tabClicked === 'submitted'}">Submitted</a></li>
                      <li class="list-inline-item"><a (click)="populateTabData('inTransit','IN_PROCESS');resetCheckedList(); tabChange()" (click)="cancelMultiReturnOrders(orders)" [ngClass]="{'active': tabClicked === 'inTransit'}">In Process</a></li>
                      <li class="list-inline-item"><a (click)="populateTabData('received','RECEIVED');resetCheckedList(); tabChange()" [ngClass]="{'active': tabClicked === 'received'}">Received</a></li>
                      <li class="list-inline-item"><a (click)="populateTabData('completed','COMPLETED');resetCheckedList(); tabChange()" [ngClass]="{'active': tabClicked === 'completed'}">Completed</a></li>
                      <li class="list-inline-item"><a (click)="populateTabData('cancelled','CANCELLED');resetCheckedList(); tabChange()" [ngClass]="{'active': tabClicked === 'cancelled'}">Cancelled</a></li>
                  </ul>
      -->
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of returnsMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
        </ng-container>
        <li class="list-inline-item">
          <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
          <div class="dropdown-menu dropdown-menu2">
            <ng-container *ngFor="let om of returnsMainMenu">
              <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                 (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
            </ng-container>
          </div>
        </li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
        <option *ngFor="let u of returnsMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
      </select>
    </div>
    <div class="col text-right">
      <div class="d-inline" *ngIf="tabClicked !== 'received' && tabClicked !== 'completed' && tabClicked !== 'all'">
        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn ml-2 btn-outline-primary dropdown-toggle d-none-mobile btn-sm" *ngIf="(checkedList?.length)">
          Actions
        </button>
        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right" *ngIf="(checkedList?.length)">
          <!--
          <a *ngIf="tabClicked === 'completed'" (click)="editReturns(orders)" class="dropdown-item file btn shift-import" disabled="orders.length > 1">Return</a>
-->
          <a *ngIf="tabClicked === 'submitted'"  (click)="processingOrder(orders)" class="dropdown-item file btn shift-import">Process Order</a>
          <a *ngIf="tabClicked === 'submitted'" class="dropdown-item file btn shift-import" (click)="onCancel()">Cancel the Return
            Request</a>
          <a *ngIf="tabClicked === 'inTransit'" class="dropdown-item file btn shift-import">Cancel the Return
            Request</a>
        </div>
      </div>
      <div class="d-inline">
        <a placement="bottom" ngbTooltip="Create" class="ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createReturnManually" width="30" height="30"
               viewBox="0 0 30 30">
            <defs>
              <style>.a{fill:#8a55bb;}.b{fill:#fff;}</style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                    transform="translate(2.823 3.938)"/>
            </g>
          </svg>
        </a>
        <!-- <button type="button" routerLink="/admin/createReturnManually"  class="btn btn-outline-primary btn-sm ml-2" style="border-top-left-radius: 4px;
 border-bottom-left-radius: 4px" >
           <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
             <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
             <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
           </svg>Create
         </button>-->
      </div>
    </div>


  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th [hidden]="tabClicked ==='all' || tabClicked === 'Awaiting Carrier'">
              <!--<div class="form-checkbox" *ngIf="tabClicked !== 'received' && tabClicked !== 'completed'">
                  <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                  <label for="all_items"></label>
              </div>-->
            </th>
            <th>Order#</th>
            <th>Source Order#</th>
            <th>Order Date</th>
            <th>Sender Name</th>
            <th>Receiver Name</th>
            <th>Source Order Date</th>
            <th>Reason</th>
            <th>Status</th>
            <!--              <th [hidden]="tabClicked === 'returned'">Action</th>-->
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td [hidden]="tabClicked === 'all' || tabClicked === 'Awaiting Carrier'">
              <div class="form-checkbox" *ngIf="tabClicked !== 'received' && tabClicked !== 'completed'">
                <input type="checkbox" id="{{o.returnOrderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                       (change)="selectShip(o)">
                <label for="{{o.returnOrderHeaderId}}"></label></div>
            </td>
            <td style="text-transform:capitalize;"><a routerLink="/admin/viewReturnOrder/{{o.orderNumber}}">{{o.orderNumber}}</a>
            </td>
            <td style="text-transform:capitalize;">{{o.sourceOrderNum || '--'}}</td>
            <td>{{o.orderedDate}}</td>
            <td style="text-transform:capitalize;">{{o.senderName}}</td>
            <td style="text-transform:capitalize;">{{o.receiverName}}</td>
            <td>{{o.sourceOrderDate || '--'}}</td>
            <td>{{o.returnReason || '--'}}</td>
            <td>{{(o.orderStatus == 'SUBMITTED' ? 'Submitted': (o.orderStatus == 'RETURN' ? 'Return' : (o.orderStatus ==
              'PROCESSING' ? 'Processing' : (o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned': (o.orderStatus
              == 'SHIPPED'
              ? 'Shipped': (o.orderStatus == 'COMPLETED' ? 'Completed': (o.orderStatus == 'CANCELLED' ? 'Cancelled':
              (o.orderStatus == 'EXCEPTION' ? 'Exception': (o.orderStatus == 'TO_PICK' ? 'Ready to Pick': (o.orderStatus
              == 'PICK_ASSIGNED'
              ? 'Picker Assigned': (o.orderStatus == 'TO_PACK' ? 'To Pack': (o.orderStatus == 'GENERATED' ? 'Generated':
              (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier': (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
              (o.orderStatus
              == 'GENERATE_LABEL' ? 'Generate Label': (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated':
              (o.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned': (o.orderStatus == 'DELIVERED' ? 'Delivered':
              (o.orderStatus == 'ON_HOLD'
              ? 'On Hold': (o.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted': o.orderStatus ))))))))))))))))))))
              |titlecase}}
            </td>
            <!--              <td [hidden]="tabClicked === 'returned'">-->
            <!--                <button routerLink="/admin/createReturns/{{o.orderHeaderId}}" class="btn btn-orange ml-3">Return</button>-->
            <!--              </td>-->
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td colspan="7" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order#</th>
            <th>Source Order#</th>
            <th>Order Date</th>
            <th>Sender Name</th>
            <th>Receiver Name</th>
            <th>Status</th>
            <!--              <th [hidden]="tabClicked === 'returned'">Action</th>-->
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td><b class=" tablesaw-cell-label">Order#</b>
              <span class="tablesaw-cell-content"><a routerLink="/admin/viewReturnOrder/{{o.orderNumber}}">{{o.orderNumber}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Order Date</b>
              <span class="tablesaw-cell-content">{{o.orderedDate}}</span></td>
            <td><b class=" tablesaw-cell-label">Source Order#</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.sourceOrderNum || '--'}}</span></td>
            <td><b class=" tablesaw-cell-label">Sender Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.senderName}}</span></td>
            <td><b class=" tablesaw-cell-label">Receiver Name</b>
              <span class="tablesaw-cell-content">{{o.receiverName}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">{{(o.orderStatus == 'SUBMITTED' ? 'Submitted': (o.orderStatus == 'RETURN' ? 'Return' : (o.orderStatus == 'PROCESSING' ? 'Processing' : (o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned': (o.orderStatus == 'SHIPPED'
                                ? 'Shipped': (o.orderStatus == 'COMPLETED' ? 'Completed': (o.orderStatus == 'CANCELLED' ? 'Cancelled': (o.orderStatus == 'EXCEPTION' ? 'Exception': (o.orderStatus == 'TO_PICK' ? 'Ready to Pick': (o.orderStatus == 'PICK_ASSIGNED'
                                ? 'Picker Assigned': (o.orderStatus == 'TO_PACK' ? 'To Pack': (o.orderStatus == 'GENERATED' ? 'Generated': (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier': (o.orderStatus == 'IN_TRANSIT' ? 'In Transit': (o.orderStatus
                                == 'GENERATE_LABEL' ? 'Generate Label': (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': (o.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned': (o.orderStatus == 'DELIVERED' ? 'Delivered': (o.orderStatus == 'ON_HOLD'
                                ? 'On Hold': (o.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted': o.orderStatus )))))))))))))))))))) |titlecase}}
              </span></td>
            <!--              <td [hidden]="tabClicked === 'returned'">-->
            <!--                <button routerLink="/admin/createReturns/{{o.orderHeaderId}}" class="btn btn-orange ml-3">Return</button>-->
            <!--              </td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div [ngClass]="{'modal': cancelPopUp == 'Y'}" [ngStyle]="{'display': cancelPopUp =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="cancelPop" role="dialog"
     style="overflow-y:auto"
     tabindex="-1" value="cancel">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button (click)="cancelPopUpClose()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-1 mb-4">
            <div class="col form-group">
              <label class="control-label" for="cancelReason">Cancel Reason</label>
              <input id="cancelReason" (blur)="typeError()" type="=text" placeholder="Please Enter the Reason for Cancellation"
                     [(ngModel)] = "cancelReason" [ngModelOptions]="{standalone:true}" [ngClass]="{'is-invalid':cancelReasonError}" class="text-center form-control w-75"/>
              <div [hidden]="!cancelReasonError" class="invalid-feedback d-block shift-invalid-login">
                {{cancelReasonError}}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button (click)="cancelPopUpClose()" class="btn btn-orange me-2" type="submit">Cancel</button>
              <button  class="btn btn-orange ml-2" (click)="returnCancel()" type="submit">Submit</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
